import { useFormContext } from "react-hook-form";
import Select from "@medoma/components/Select/Select";
import type { SiteId } from "@medoma/models/sites";
import { useTeams } from "@/api/Patients";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { useLingui } from "@lingui/react/macro";

export type TeamSelectFields = {
  teamId: string;
};

const TeamSelect = ({ siteId }: { siteId: SiteId }) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<TeamSelectFields>();

  const {
    data: teams,
    isPending: isPendingTeams,
    isError: isErrorTeams,
  } = useTeams(siteId);

  if (isErrorTeams) {
    return (
      <ErrorMessage
        message={t`Kunde inte hämta team. Försök igen om en liten stund. Kontakta support om problemet kvarstår.`}
      />
    );
  }

  if (isPendingTeams) {
    return (
      <Select label={t`Team`} name="teamId">
        <option>{t`Hämtar team`}...</option>
      </Select>
    );
  }

  return (
    <Select
      label={t`Team`}
      {...register("teamId")}
      errorMessage={errors.teamId?.message}
    >
      <option value={""}>{t`Inget`}</option>
      {teams.map((team) => (
        <option value={team.id.toString()} key={team.id}>
          {team.displayName}
        </option>
      ))}
    </Select>
  );
};

export default TeamSelect;
